// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2I4OfMJnGueIMGsevB\\+n-Q\\=\\= .logo{height:30px}", "",{"version":3,"sources":["/app/client_react/src/components/SignUp/VerifyEmail/VerifyEmail.styl"],"names":[],"mappings":"AACE,oCACE,WAAQ","file":"VerifyEmail.styl","sourcesContent":[":local(.global) {\n  .logo {\n    height: 30px;\n  }\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "_2I4OfMJnGueIMGsevB+n-Q=="
};
module.exports = ___CSS_LOADER_EXPORT___;
